import { useState } from 'react';

/**
 * 用于数据层（各 useData.ts），管理宽表 API 响应后的超限 bar 触发逻辑。
 *
 * 使用方式：
 * 1. API 成功后调用 handleResponse(frontLogicalFlag) 决定是否递增计数器
 * 2. 将 overLimitBarTriggerKey 透传给 PerformanceMetricsTable / HeatMapTable
 */
export function useOverLimitTrigger() {
  const [overLimitBarTriggerKey, setOverLimitBarTriggerKey] = useState(0);

  const handleResponse = (frontLogicalFlag?: string) => {
    if (frontLogicalFlag === 'has_more') {
      setOverLimitBarTriggerKey(k => k + 1);
    }
  };

  return { overLimitBarTriggerKey, handleResponse };
}

/**
 * 用于渲染层（PerformanceMetricsTable、HeatMapTable），返回超限提示可见状态。
 * - tipVisible：只要 frontLogicalFlag === 'has_more' 就为 true，无需额外配置
 */
export function useOverLimitTip(frontLogicalFlag?: string) {
  return { tipVisible: frontLogicalFlag === 'has_more' };
}
